import { Col, DateRangePickerField } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const PeriodColField: FC = memo(() => {
  const { t } = useTranslation();
  const {
    control: sharedSearchControl,
    formState: { errors },
  } = useFormContext<SharedSearchFormType>();

  const { control: projectSearchControl } =
    useFormContext<ProjectSearchFormType>();

  const sheetType = useWatch({
    control: sharedSearchControl,
    name: 'sheetType',
  });

  const fundSheetType = useWatch({
    control: projectSearchControl,
    name: 'fundSheetType',
  });

  if (sheetType === 'KS' && fundSheetType === 'local-government') {
    return null;
  }

  return (
    <Col span={8} style={{ minWidth: COL_MIN_WIDTH.large }}>
      <DateRangePickerField
        name="period"
        label={t('period')}
        control={sharedSearchControl}
        errors={errors}
        picker="year"
        allowEmpty={[true, true]}
        fieldStyle={{ width: '100%' }}
      />
    </Col>
  );
});
